module.exports = __webpack_public_path__ + "img/img12.167a5999.jpg";